import { type IDeferred } from 'angular';

export class A9Promise<T> implements IDeferred<T> {
    private readonly _promise: Promise<T>;
    private promiseResolve: (value: T | PromiseLike<T>) => void;
    private promiseReject: (reason?: any) => void;

    constructor() {
        this._promise = new Promise<T>((resolve, reject) => {
            this.promiseResolve = resolve;
            this.promiseReject = reject;
        });
    }

    public get promise(): Promise<T> {
        return this._promise;
    }

    public resolve(result: T | PromiseLike<T>) {
        return this.promiseResolve(result);
    }

    public reject(result?: any) {
        return this.promiseReject(result);
    }

    public notify(state: any): void {
        console.warn('Implement notify method in A9Promise');
    }
}
